import { APP_SETTINGS } from '@constants/constants';
import { ProviderUserProfile } from '@customTypes/user';

/**
 * HubSpot Chat Widget
 * @see https://developers.hubspot.com/docs/api-reference/latest/conversations/chat-configuration/chat-widget-sdk
 * @see https://developers.hubspot.com/docs/api-reference/legacy/conversations/visitor-identification/guide
 */

/**
 * Initialize the HubSpot Chat widget in a delayed state
 * so that it can be loaded once the user is identified
 * @returns {boolean} True if initialized, false otherwise
 */
export const initHubSpotChatWidget = (): boolean => {
  if (!APP_SETTINGS.hubspotAccountId) {
    return false;
  }

  window.hsConversationsSettings = {
    loadImmediately: false,
  };

  const script = document.createElement('script');

  script.src = `https://js.hs-scripts.com/${APP_SETTINGS.hubspotAccountId}.js`;
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);

  return true;
};

/**
 * Identify the user in HubSpot
 * @param email {string} The user's email address
 * @param token {string} The user's token
 */
export const identifyHubSpotUser = (userProfile: ProviderUserProfile): void => {
  window.hsConversationsSettings = {
    identificationEmail: userProfile.email,
    identificationToken: userProfile.hubspot_id_token || '',
  };

  window.HubSpotConversations?.widget?.load();

  disableHubSpotTracking();
};

/**
 * Disable HubSpot tracking so we do not send patient PII unintentionally
 * @see https://developers.hubspot.com/docs/api-reference/latest/account/settings/tracking-code/do-not-track
 */
export const disableHubSpotTracking = (): void => {
  window._hsq?.push(['doNotTrack']);
};
